import React, { useEffect, useRef } from 'react';
import Glide from '@glidejs/glide';
import { useTranslation } from 'react-i18next';

const Testimonials = ({ content }) => {
  const { t } = useTranslation();
  const sliderRef = useRef(null);

  useEffect(() => {
    // Initialize Glide slider
    const glideInstance = new Glide(sliderRef.current, {
      type: 'carousel',
      perView: 1,
      focusAt: 'center',
      gap: 0,
      autoplay: 3000,
      animationDuration: 1000
    });
    
    glideInstance.mount();
    
    // Cleanup on component unmount
    return () => {
      glideInstance.destroy();
    };
  }, []);

  return (
    <section id="testimonials" className="py-20">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center mb-16">{t('testimonials.title')}</h2>
        <div className="glide" ref={sliderRef}>
          <div className="glide__track" data-glide-el="track">
            <ul className="glide__slides">
              {content.items.map((testimonial, index) => (
                <li key={index} className="glide__slide">
                  <div className="max-w-2xl mx-auto text-center">
                    <p className="text-xl text-gray-600 mb-6">{t(`testimonials.items.${index}.quote`)}</p>
                    <h4 className="font-semibold">{t(`testimonials.items.${index}.name`)}</h4>
                    <p className="text-gray-500">{t(`testimonials.items.${index}.position`)}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="glide__bullets mt-8" data-glide-el="controls[nav]">
            {content.items.map((_, index) => (
              <button 
                key={index} 
                className="glide__bullet" 
                data-glide-dir={`=${index}`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
